import { buildingsIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Building = createIcon({
  displayName: 'Building',
  paths: [
    'M810.667 85.333h-426.667c-47.104 0-85.333 38.229-85.333 85.333v170.667h-85.333c-47.104 0-85.333 38.229-85.333 85.333v426.667c0 47.104 38.229 85.333 85.333 85.333h597.333c47.104 0 85.333-38.229 85.333-85.333v-682.667c0-47.104-38.229-85.333-85.333-85.333zM384 853.333v-682.667h426.667v682.667h-128v-85.333h-170.667v85.333h-128zM213.333 426.667h85.333v85.333h-85.333v-85.333zM213.333 597.333v85.333h85.333v-85.333h-85.333zM213.333 768v85.333h85.333v-85.333h-85.333zM554.667 682.667h-85.333v-85.333h85.333v85.333zM640 512h85.333v-85.333h-85.333v85.333zM554.667 512h-85.333v-85.333h85.333v85.333zM640 682.667h85.333v-85.333h-85.333v85.333zM640 341.333h85.333v-85.333h-85.333v85.333zM554.667 341.333h-85.333v-85.333h85.333v85.333z'
  ],
  canvasPaths: canvasIconPaths(buildingsIcon)
})
